import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { loadMyChildrenList, myReportsModule } from "../../MyReports/MyReportsDucks";
import StaticTablePaginated from '../../../_ui/Table/StaticTablePaginated';
import { useTranslation } from 'react-i18next';
import useSimpleModal from '../../../components/_hooks/useSimpleModal';
import RefreshIcon from '@material-ui/icons/Refresh';
import {
  enableIntegrationForServices,
  serviceRequestModule, setIntegrationLoading,
  setIntegrationStatus
} from '../../ServiceRequest/ServiceRequestDucks';
import IntegrationModal from '../../../components/IntegrationModal/IntegrationModal';
import IconButton from "@material-ui/core/IconButton";
import { AccountSettingsApi } from '../AccountSettingsApi';
import { handleError } from '../../../modules/utils/handleError';
import i18next from 'i18next';
import Notice from '../../../modules/utils/Notice';
import useDict from '../../../modules/_hooks/useDict';

const MyChildren = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { data, loading } = useSelector(state => state[myReportsModule]);
  const { loadingIntegration,kdpZagsStatus,kdpGbdflStatus } = useSelector(state => state[serviceRequestModule]);

  const integrationModal = useSimpleModal();
  const pollingTimeoutRef = useRef(null);
  const [showHelperText, setShowHelperText] = useState();
  const [selectedChildIin, setSelectedChildIin] = useState();
  const genderDict = useDict('50');




  useEffect(() => {
    dispatch(loadMyChildrenList());
  }, [dispatch]);

  const updateChildAfterIntegration = async (childIin) => {
    try {
      const response = await AccountSettingsApi.updateMyChildrenData(childIin);

      if (response.status === 200) {
        await dispatch(loadMyChildrenList());
        Notice.success(i18next.t('accountSettings_successUpdatedChildInfo'));
      }
    } catch (e) {
      handleError(e, i18next.t('accountSettings_errorUpdateChildInfo'));
    }
  };


  const handleZagsPolling = () => {
    enableIntegrationForServices({
      close: integrationModal.close,
      onStatus: async (status) => {
        if (status === 'PENDING') {
          pollingTimeoutRef.current = setTimeout(() => {
            if (integrationModal.isOpen) {
              handleZagsPolling();
            }
          }, 10000);
        }
        if (status === 'VALID' && selectedChildIin) {
          await updateChildAfterIntegration(selectedChildIin);
          integrationModal.close();
        }
      },
    })(dispatch);
  };




  const onZagsAutoFill = () => {
    setShowHelperText(false);
    handleZagsPolling();
  };

  const clearResources = () => {
    clearTimeout(pollingTimeoutRef.current);
    pollingTimeoutRef.current = null;
    setIntegrationStatus(null);
    setIntegrationLoading(false);
  };
  const onDonIntegration = () => {
    setShowHelperText(true);
    clearResources();
  };


  const columns = [
    {
      Header: t('accountSettings_myChildIIN'),
      accessor: "iin",
      style: { textAlign: "center" },

    },
    {
      Header: t('accountSettings_myChildSurname'),
      accessor: "lastname",
      style: { textAlign: "center" },
    },
    {
      Header: t('accountSettings_myChildName'),
      accessor: "firstname",
      style: { textAlign: "center" },
    },
    {
      Header: t('accountSettings_myChildBirthday'),
      accessor: "birthday",
      style: { textAlign: "center" },
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
    {
      Header: t('accountSettings_myChildGender'),
      accessor: "childGender",
      style: { textAlign: "center" },
      Cell: ({ value }) => {
        if (!genderDict?.length) return '';
        const dictItem = genderDict.find(
          (item) => item.code === String(value)
        );
        if (!dictItem) return '';
        const langKey = `${i18n.language}_name`;
        const name = dictItem[langKey];
        return name?.replace(/\s*\[\d+]$/, '') || '';
      },
    },
    {
      Header: t('accountSettings_updateChildrenData'),
      id: "update",
      style: { textAlign: "center" },
      Cell: ({ row }) => (
          <IconButton
              onClick={() => {
                const iin = row.iin;
                if (!iin) return;
                setSelectedChildIin(iin);
                integrationModal.open({
                  iin,
                  lastname: row.lastname,
                  firstname: row.firstname,
                });
              }}
              disabled={loadingIntegration}
          >
            <RefreshIcon />
          </IconButton>

      )
    }
  ];


  useEffect(() => {
    return () => {
      if (pollingTimeoutRef.current) {
        clearTimeout(pollingTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        {integrationModal.isOpen && (
          <IntegrationModal
            title="kindergarten_integrationTitle"
            {...integrationModal}
            onDonIntegration={onDonIntegration}
            onZagsInit={onZagsAutoFill}
            loadingIntegration={loadingIntegration}
            helperText={showHelperText}
            kdpGbdflStatus={kdpGbdflStatus}
            kdpZagsStatus={kdpZagsStatus}
            clearResources={clearResources}
            setShowHelperText={setShowHelperText}
          />
        )}
      </div>
      <StaticTablePaginated
        pageNumber={0}
        loading={loading}
        data={data}
        totalElements={data.totalElements}
        columns={columns}
        filterable={false}
        pagePagination={() => {}}
      />
    </div>
  );
};

export default MyChildren;
